import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {setRedirectTo} from '../actions';
import {connect} from 'react-redux';

export default (ComposedComponent)=>{

    class Authentication extends PureComponent{
        componentDidMount(){
            if(!this.props.authenticated){
                if(this.context.router.route.location.search.indexOf("code") !== -1) {
                    this.props.setRedirectTo(this.context.router.route.location.pathname + this.context.router.route.location.search);
                }
                return this.context.router.history.push('/');
            }
        }
        render(){
            return this.props.authenticated ? <ComposedComponent {...this.props}/> : null;
        }
    }

    Authentication.contextTypes = {
        router:PropTypes.object
    }

    function mapStateToProps(state){
        return {...state.auth}
    }

    return connect(mapStateToProps,{setRedirectTo})(Authentication);
}


// WEBPACK FOOTER //
// ./src/containers/Auth.js